import React from 'react';
import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import PropTypes from 'prop-types';

export default class SnackbarNotifier extends React.Component {
  constructor() {
    super();
    this.displayed = [];
  }

  componentDidUpdate() {
    const { notifications, enqueueSnackbar, removeSnackbar, closeSnackbar } = this.props;

    notifications.forEach((notification) => {
      // Do nothing if snackbar is already displayed
      if (this.displayed.includes(notification.key)) return;
      // Display snackbar using notistack
      /* istanbul ignore next */
      const action = (key) => (
        <IconButton
          key="close"
          aria-label="Close"
          onClick={() => {
            closeSnackbar(key);
          }}
          color="inherit"
        >
          <CloseIcon />
        </IconButton>
      );
      enqueueSnackbar(notification.message, { ...notification.options, action });
      // Keep track of snackbars that we've displayed
      this.storeDisplayed(notification.key);
      // Dispatch action to remove snackbar from redux store
      removeSnackbar(notification.key);
    });
  }

  storeDisplayed(key) {
    this.displayed = [...this.displayed, key];
  }

  render() {
    return null;
  }
}

SnackbarNotifier.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  enqueueSnackbar: PropTypes.func.isRequired,
  removeSnackbar: PropTypes.func.isRequired,
  closeSnackbar: PropTypes.func.isRequired,
};
